export default "__VITE_ASSET__e4c30889__"